export default interface MinecraftFeatureBase {
  format_version: string;
}
